<div class="share-this" (click)="shareThis()">
  <div class="share-icon"></div>
</div>

<div class="share-links" [ngClass]="{'share-links-ac': shareThisAc, 'share-links-nac': !shareThisAc&& !isFirstLoadShare}">

      <div class="share-link-item" title="facebook" (click)="shareThis()">
          <a href="https://www.facebook.com/sharer/sharer.php?u={{currentPage}}"  target="blank">
            <img src="/assets/F_icon.svg" class="share_logo" alt="שלחו הודעה בפייסבוק">
          </a>
        </div>
        <div class="share-link-item" title="WhatsApp" (click)="shareThis()">
            <a href="https://api.whatsapp.com/send?&text={{currentPage}}{{shareTxt}}" target="blank">
              <img src="/assets/online_design/WhatsApp_Logo.gif" class="share_logo" alt="שלחו הודעה בוואטצאפ">
            </a>
        </div>
        <div class="share-link-item share-sms"  title="sms" (click)="shareThis()">
          <a href="sms://&body=בדיוק מה שצריך https://archonline.co.il/" target="blank">
       
            <fa-icon [icon]="['fas', 'comment']" ></fa-icon>
          </a>
      </div>
      <div class="share-link-item share-sms" title="אימייל" (click)="shareThis()">
        <a href="mailto://?Subject=תכנון%20אונליין&body={{currentPage}}{{shareTxt}}/" target="blank">
     
          <fa-icon [icon]="['far', 'envelope']" class="share_logo" alt="שלחו הודעה באימייל"></fa-icon>


        </a>
    </div>
</div>